import { render, staticRenderFns } from "./OptimizationVizWidget.vue?vue&type=template&id=b3898fca&scoped=true&"
import script from "./OptimizationVizWidget.vue?vue&type=script&lang=js&"
export * from "./OptimizationVizWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3898fca",
  null
  
)

export default component.exports